<template>
  <div class="pb-4">
    <header class="card__container">
      <!-- Customer Detail Start -->
      <div class="header__container">
        <div class="d-flex justify-content-between align-items-start">
          <label class="text__header"
            >Site Access ID : {{ siteAccessId }}</label
          >

          <b-badge pill :variant="badgeVariant" class="badge--style tag--space">
            {{ badgeStatus }}
          </b-badge>
        </div>
        <div class="d-md-flex mt-1 mt-md-0 flex-wrap">
          <label class="text__customer-detail_topic">Customer Name</label>
          <label class="text__customer-detail_data ml-md-2">{{
            customerDetail.name
          }}</label>
        </div>
        <div class="d-md-flex mt-1 mt-md-0 flex-wrap">
          <label class="text__customer-detail_topic">{{
            contractIdLabel
          }}</label>
          <label class="text__customer-detail_data ml-md-2">{{
            customerDetail.idcId
          }}</label>
        </div>
      </div>
      <!-- Customer Detail End -->

      <hr />

      <!-- QR Access Detail Start -->
      <div class="header__container">
        <div v-if="isEditDetail">
          <div class="d-flex flex-column col-12 col-lg-9 px-0">
            <div class="d-lg-flex w-100">
              <div class="col-12 col-lg-6 px-0 pr-lg-1">
                <atom-datepicker
                  datepickerId="request_start_date"
                  title="Request Start Date"
                  :isAsterisk="true"
                  v-model="requestDetail.startDate"
                  placeholder="Request Start Date"
                  :minDate="minSiteAccessRequestStartDate"
                  :maxDate="requestDetail.endDate"
                  type="dateNtime"
                  :isError="validateRequestDetailError.startDate"
                  errorMessage="Please enter start date"
                  :showSetTimeNowButton="true"
                ></atom-datepicker>
              </div>
              <div class="col-12 col-lg-6 px-0 mt-1 mt-lg-0 pl-lg-1">
                <atom-datepicker
                  datepickerId="request_end_date"
                  title="Request End Date"
                  :isAsterisk="true"
                  v-model="requestDetail.endDate"
                  placeholder="Request End Date"
                  :minDate="requestDetail.startDate"
                  :maxDate="maxSiteAccessRequestEndDate"
                  type="dateNtime"
                  :isError="validateRequestDetailError.endDate"
                  errorMessage="Please enter end date"
                  :showSetTimeNowButton="true"
                ></atom-datepicker>
              </div>
            </div>

            <atom-text-area
              v-model="requestDetail.description"
              title="Description"
              placeholder="Description"
              :isAsterisk="true"
              :isError="validateRequestDetailError.description"
              errorMessage="Please enter description"
              class="mt-1"
            ></atom-text-area>
          </div>

          <div class="mt-2 col-12 col-lg-9 px-0">
            <b-alert :show="true" variant="secondary" class="w-100">
              <div class="alert-body">
                <strong>Please Note:</strong> Please specify the entry and
                exit date/time to cover your entire visit. <br />Access is
                not permitted before the Start Date or after the End Date.
                <br />For visits longer than one day, you can specify a
                date range in a single Site Access request.
              </div>
            </b-alert>
          </div>

          <div class="d-flex justify-content-end mt-2">
            <atom-button
              buttonId="btn-save-detail"
              @click="onClickSaveDetail"
              :isDisable="isRequestDetailError"
              >Save Changes</atom-button
            >
            <atom-button
              buttonId="btn-cancel-save-detail"
              buttonStyle="border"
              buttonColor="secondary"
              @click="onClickCancelSaveDetail"
              class="ml-12px"
              >Cancel</atom-button
            >
          </div>
        </div>

        <div v-else class="d-flex justify-content-between align-items-start">
          <div class="d-flex flex-column col-lg-9 px-0">
            <div class="d-lg-flex">
              <div class="col-12 col-lg-6 px-0 pr-lg-1 d-md-flex">
                <div class="w-150px text__normal">Request Start Date:</div>
                <span class="text__medium">{{ startDate }}</span>
              </div>
              <div class="col-12 col-lg-6 px-0 mt-1 mt-lg-0 pl-lg-1 d-md-flex">
                <div class="w-150px text__normal">Request End Date:</div>
                <span class="text__medium">{{ endDate }}</span>
              </div>
            </div>
            <div class="mt-1 d-md-flex">
              <div class="w-150px text__normal">Description:</div>
              <span class="text__medium w-des text-show-new-line">{{
                requestDetail.description
              }}</span>
            </div>
          </div>

          <atom-button
            v-if="isEditRequest"
            buttonId="btn-edit-request"
            iconLeft="EditIcon"
            buttonStyle="flat"
            buttonColor="secondary"
            class="btn-edit-request"
            @click="isEditDetail = !isEditDetail"
          ></atom-button>
        </div>

        <div v-if="!isEditDetail" class="mt-2 col-12 col-lg-10 col-xl-8 px-0">
          <b-alert :show="true" variant="secondary" class="w-100">
            <div class="alert-body">
              <strong>Please Note:</strong> Please specify the entry and
              exit date/time to cover your entire visit. <br />Access is
              not permitted before the Start Date or after the End Date.
              <br />For visits longer than one day, you can specify a date
              range in a single Site Access request.
            </div>
          </b-alert>
        </div>

      </div>
      <!-- QR Access Detail End -->
    </header>

    <!-- Visitor Detail Start -->
    <molecule-visitor-card-group
      :idTypeOptions="idTypeOptions"
      :requestStatus="siteAccessStatus"
      :visitorListProp="visitorList"
      :validateVisitorError="validateRequestDetailError.visitor"
      :isShowPrivacyNotice="false"
      @clickCopyVisitorListCreateNewSiteAccess="
        onClickCopyVisitorListCreateNewSiteAccess
      "
      @updateVisitorList="onUpdateVisitorList"
      class="mt-30px"
    />
    <!-- Visitor Detail End -->

    <!-- Attachment Start -->
    <div class="mt-30px">
      <molecule-attachment-list
        :attachmentList="attachmentList"
        :requestStatus="siteAccessStatus"
        :tagList="tagList"
        :hasEditPermission="true"
        @onRequestAddAttachment="onRequestAddAttachment"
        @onRequestEditAttachment="onRequestEditAttachment"
        @onRequestDeleteAttachment="onRequestDeleteAttachment"
      ></molecule-attachment-list>
    </div>
    <!-- Attachment End -->

    <!-- Button Delete Request Start -->
    <atom-button
      v-if="isWaiting || (isInternalAccess && isRejected)"
      buttonId="btn-delete"
      buttonStyle="border"
      buttonColor="danger"
      iconLeft="Trash2Icon"
      @click="onClickDeleteRequest"
      class="w-115px mt-30px"
      >Delete</atom-button
    >
    <!-- Button Delete Request End -->

    <!-- Modal Start -->
    <div>
      <!-- start modal delete access-->
      <molecule-modal-dialog
        modalId="modal-confirm-delete-site-access"
        icon="AlertCircleIcon"
        textTitle="Do you want to delete?"
        :textSubtitle="`Site Access ID: ${this.siteAccessId}`"
        buttonTextLeft="Delete"
        buttonTextRight="Cancel"
        buttonColorLeft="danger"
        :isTextCenter="true"
        @clickButtonLeft="onClickConfirmDeleteRequest"
      >
      </molecule-modal-dialog>
      <!-- end modal delete access -->
    </div>
    <!-- Modal End -->
  </div>
</template>

<script>
import { getSharedTags } from "@/api/api-module1"
import {
  getExternalSiteAccessById,
  updateExternalSiteAccessById,
  deleteExternalSiteAccessById,
  addExternalAttachmentById,
  editExternalAttachmentById,
  deleteExternalAttachmentById,
} from "@/api/module-1/site-access"
import { mapGetters } from "vuex"
import mixins from "@/mixins"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import { BBadge, BAlert } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeAttachmentList from "@/components/molecules/portal/idc/MoleculeAttachmentList.vue"
import MoleculeVisitorCardGroup from "@/components/molecules/portal/qrAccess/MoleculeVisitorCardGroup.vue"
import { DateTime } from "luxon"

export default {
  name: "OrganismQrAccessDetail",
  components: {
    BBadge,
    AtomButton,
    AtomDatepicker,
    AtomTextArea,
    MoleculeModalDialog,
    MoleculeAttachmentList,
    MoleculeVisitorCardGroup,
    BAlert,
  },
  mixins: [mixins, mixinsDateTime, mixinsValidator, mixinsObjectHelper],
  props: {
    attachmentTagOption: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      idTypeOptions: [
        {
          id: "ID_CARD",
          name: "ID Card",
        },
        {
          id: "PASSPORT",
          name: "Passport",
        },
      ],

      siteAccessId: null,
      siteAccessStatus: null,

      customerDetail: {
        name: null,
        idcId: null,
      },

      isEditDetail: false,

      originRequestDetail: {
        startDate: null,
        endDate: null,
        description: null,
      },
      requestDetail: {
        startDate: null,
        endDate: null,
        description: null,
      },

      isApplyValidateRequestDetail: false,
      validateRequestDetailError: {
        startDate: false,
        endDate: false,
        description: false,
        visitor: false,
      },

      visitorList: [],

      attachmentList: [],
      tagList: [],
    }
  },
  computed: {
    ...mapGetters("appPermission", [
      "getFullName",
      "getIdcId",
      "getCustomerSitePermissions",
    ]),

    isInternalAccess() {
      return this.$route.meta.type === "internal"
    },

    customerName() {
      return this.getFullName || "-"
    },
    idcId() {
      return !!this.getIdcId ? this.getIdcId.toString().padStart(8, "0") : "-"
    },
    isWaiting() {
      return this.siteAccessStatus === "WAITING"
    },
    isAccess() {
      return this.siteAccessStatus === "ACCESS"
    },
    isRejected() {
      return this.siteAccessStatus === "REJECTED"
    },
    isClosed() {
      return this.siteAccessStatus === "CLOSED"
    },

    isEditRequest() {
      return (
        this.isWaiting ||
        (this.isInternalAccess && !this.isRejected && !this.isClosed)
      )
    },

    isDeleteRequest() {
      return (
        this.isWaiting ||
        (this.isInternalAccess && (this.isAccess || this.isClosed))
      )
    },

    badgeVariant() {
      if (this.siteAccessStatus === "WAITING") return "light-warning"
      if (this.siteAccessStatus === "APPROVED") return "light-success"
      if (this.siteAccessStatus === "ACCESS") return "light-primary"
      if (this.siteAccessStatus === "REJECTED") return "light-danger"
      return "light-secondary"
    },

    badgeStatus() {
      if (this.siteAccessStatus === "WAITING") return "Waiting"
      if (this.siteAccessStatus === "APPROVED") return "Approved"
      if (this.siteAccessStatus === "ACCESS") return "Access"
      if (this.siteAccessStatus === "REJECTED") return "Rejected"
      return "Closed"
    },

    startDate() {
      return this.setDateTimeFormat(
        this.requestDetail.startDate,
        "dd/MM/yyyy HH:mm"
      )
    },

    endDate() {
      return this.setDateTimeFormat(
        this.requestDetail.endDate,
        "dd/MM/yyyy HH:mm"
      )
    },

    isRequestDetailError() {
      return Object.values(this.validateRequestDetailError).some(
        (error) => error === true
      )
    },

    maxSiteAccessRequestEndDate() {
      if (!this.requestDetail.startDate) return null

      return DateTime.fromISO(this.requestDetail.startDate)
        .plus({ days: 30 })
        .set({ hour: 23, minute: 59, second: 59 })
        .toISO({ suppressMilliseconds: true })
    },

    minSiteAccessRequestStartDate() {
      return DateTime.now()
        .startOf("day")
        .set({ second: 0, millisecond: 0 })
        .toISO({ suppressMilliseconds: true })
    },
  },
  watch: {
    requestDetail: {
      deep: true,
      handler() {
        this.validateRequestDetail()
      },
    },
  },
  async mounted() {
    this.siteAccessId = this.$route?.params?.id.toString()

    this.customerDetail = {
      name: this.customerName,
      idcId: this.idcId,
    }

    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.showLoading(true)
      await getExternalSiteAccessById(this.siteAccessId)
        .then((data) => {
          this.siteAccessStatus = data.status

          this.requestDetail = {
            startDate: data.requestStartDate,
            endDate: data.requestEndDate,
            description: data.description,
          }
          this.originRequestDetail = this.deepCopyObject(this.requestDetail)

          this.visitorList = data.visitors.map((visitor) => ({
            id: visitor.accessVisitorId,
            firstname: visitor.firstname,
            lastname: visitor.lastname,
            idType: this.idTypeOptions.find(
              (option) => option.id === visitor.idType
            ),
            idNumber: visitor.identity,
            email: visitor.email,
            phone: visitor.phone,
            selfCheckIn: {
              dateFirstCheckIn: visitor.selfCheckIn?.dateFirstCheckIn,
              dateLastCheckIn: visitor.selfCheckIn?.dateLastCheckIn,
              selfCheckInAt: visitor.selfCheckIn?.selfCheckInAt,
              name:
                !!visitor.selfCheckIn?.firstname &&
                !!visitor.selfCheckIn?.lastname
                  ? `${visitor.selfCheckIn?.firstname} ${visitor.selfCheckIn?.lastname}`
                  : null,
              idNumber: visitor.selfCheckIn?.identity,
              idExpiredDate: visitor.selfCheckIn?.expireDate,
              nationality: visitor.selfCheckIn?.nationality,
              address: visitor.selfCheckIn?.address,
              image: visitor.selfCheckIn?.image,
            },
            accessBuilding: visitor.accessBuildings.map((accessBuilding) => ({
              accessBuildingId: accessBuilding?.accessBuildingId,
              checkInDate: accessBuilding?.checkInDate,
              checkOutDate: accessBuilding?.checkOutDate,
              buildingCard: accessBuilding?.buildingCard,
              accessCard: accessBuilding?.accessCards.map((accessCard) => ({
                accessCardId: accessCard?.accessCardId,
                checkInDate: accessCard?.checkInDate,
                checkOutDate: accessCard?.checkOutDate,
                location: accessCard?.location,
                cardType: accessCard?.cardType,
                cardNumber: accessCard?.cardNumber,
              })),
            })),
          }))

          this.tagList = []
          this.attachmentList = data.attachment.external.map((attachment) => ({
            attachmentId: attachment.attachmentId,
            filename: attachment.filename,
            filePath: attachment.filePath,
            name: attachment.title,
            description: attachment.description,
            tags: attachment.tags,
            createAt: attachment.createAt,
            updateAt: attachment.updateAt,
          }))
        })
        .catch(() => {
          this.toastError("Site Access Not Found")
          this.$router.push({ name: "externalSiteAccessManagement" })
        })
        .finally(() => this.showLoading(false))

      await this.getAttachmentTagOptionFromApi()
    },

    async getAttachmentTagOptionFromApi() {
      const tagFilter = {
        TagTypes: [2],
      }
      await getSharedTags(tagFilter).then((response) => {
        this.tagList = response.map((item) => item.key)
      })
    },

    async onClickSaveDetail() {
      this.isApplyValidateRequestDetail = true
      this.validateRequestDetail()

      if (!this.isRequestDetailError) {
        this.isEditDetail = false
        const body = {
          requestStartDate: this.requestDetail.startDate,
          requestEndDate: this.requestDetail.endDate,
          description: this.requestDetail.description,
        }
        this.showLoading(true)
        await updateExternalSiteAccessById(this.siteAccessId, body)
          .then(() => this.toastSuccess("Site Access updated successfully"))
          .catch(() => this.toastError("Site Access updated failed"))
          .finally(() => {
            this.showLoading(false)
            this.isApplyValidateRequestDetail = false
            this.fetchData()
          })
      }
    },

    onClickCancelSaveDetail() {
      this.requestDetail = this.deepCopyObject(this.originRequestDetail)
      this.isEditDetail = false
      this.isApplyValidateRequestDetail = false
    },

    onClickDeleteRequest() {
      this.openModal("modal-confirm-delete-site-access")
    },

    async onClickConfirmDeleteRequest() {
      this.showLoading(true)

      await deleteExternalSiteAccessById(this.siteAccessId)
        .then(() => this.toastSuccess("Site Access deleted successfully"))
        .catch(() => this.toastError("Site Access deleted failed"))
        .finally(() => {
          this.closeModal()
          this.showLoading(false)
          this.$router.push({ name: "externalSiteAccessManagement" })
        })
    },

    // Visitor Start
    async onUpdateVisitorList(visitorList) {
      const updateVisitor = {
        visitor: visitorList.map((item) => {
          const visitor = {
            firstname: item.firstname,
            lastname: item.lastname,
            idType: item.idType.id,
            identity: item.idNumber,
            email: item.email,
            phone: item.phone,
          }

          if (item.id.toString().includes("NEW_VISITOR")) {
            return visitor
          }

          return {
            accessVisitorId: item.id,
            ...visitor,
          }
        }),
      }

      this.showLoading(true)

      await updateExternalSiteAccessById(this.siteAccessId, updateVisitor)
        .then(() => this.toastSuccess("Visitors updated successfully"))
        .catch(() => this.toastError("Visitors updated failed"))
        .finally(() => this.showLoading(false))
    },

    // Visitor End

    onClickCopyVisitorListCreateNewSiteAccess() {
      this.$router.push({
        name: "externalCreateNewSiteAccess",
        params: {
          siteAccessId: this.siteAccessId,
        },
      })
    },

    // Attachment Start
    async onRequestAddAttachment(attachment) {
      let formData = new FormData()
      formData.append("Title", attachment.name)
      formData.append("Description", attachment.description)
      for (let tag of attachment.tags) {
        formData.append("Tags", tag)
      }
      for (let file of attachment.uploadFile) {
        formData.append("Files", file)
      }

      this.showLoading(true)
      await addExternalAttachmentById(this.siteAccessId, formData)
        .then(() => this.toastSuccess("Site Access updated successfully"))
        .catch(() => this.toastError("Attachment uploaded failed. Please check the file size of your attachment and try again."))
        .finally(() => {
          this.fetchData()
          this.showLoading(false)
        })
    },

    async onRequestEditAttachment(attachment) {
      let formData = new FormData()
      formData.append("Title", attachment.name)
      formData.append("Description", attachment.description)
      for (let tag of attachment.tags) {
        formData.append("Tags", tag)
      }

      this.showLoading(true)
      await editExternalAttachmentById(
        this.siteAccessId,
        attachment.attachmentId,
        formData
      )
        .then(() => this.toastSuccess("Site Access updated successfully"))
        .catch(() => this.toastError("Attachment updated failed. Please check the file size of your attachment and try again."))
        .finally(() => {
          this.fetchData()
          this.showLoading(false)
        })
    },

    async onRequestDeleteAttachment(attachment) {
      this.showLoading(true)
      await deleteExternalAttachmentById(
        this.siteAccessId,
        attachment.attachmentId
      )
        .then(() => this.toastSuccess("Site Access updated successfully"))
        .catch(() => this.toastError("Site Access updated failed"))
        .finally(() => {
          this.fetchData()
          this.showLoading(false)
        })
    },
    // Attachment End

    // Validate Start
    validateRequestDetail() {
      if (!this.isApplyValidateRequestDetail) {
        this.validateRequestDetailError = this.deepCopyObject({
          startDate: false,
          endDate: false,
          description: false,
          visitor: false,
        })
      } else {
        this.validateRequestDetailError = this.deepCopyObject({
          startDate: !this.requestDetail.startDate,
          endDate: !this.requestDetail.endDate,
          description: this.isEmptyString(this.requestDetail.description),
          visitor: this.visitorList.length === 0,
        })
      }
    },
    // Validate End

    // Modal Start
    openModal(modalId) {
      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
    // Modal End
  },
}
</script>

<style lang="scss" scoped>
hr {
  width: 100%;
  stroke-width: 1px;
  stroke: #e9ecef;
}

.card__container {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
}

.header__container {
  padding: 21px;
}

.text__header {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 35px;
}

.text__customer-detail_topic {
  font-size: 14px;
  font-weight: 600;
  color: #6e6b7b;
  width: 130px;
}

.text__customer-detail_data {
  font-size: 14px;
  font-weight: 400;
  color: #5e5873;
}

.text__normal {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 400;
}

.text__medium {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 500;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag--space {
  margin-left: 4px;
  margin-bottom: 4px;
}

.mt-30px {
  margin-top: 30px;
}

.ml-12px {
  margin-left: 12px;
}

.w-150px {
  width: 150px;
}

.w-des {
  width: calc(100% - 150px);
}

.w-115px {
  width: 115px;
}

.btn-edit-request ::v-deep .padding-icon {
  padding-top: 0;
  padding-right: 0;
}
</style>
